module.exports = "/_next/static/images/d07441d5036c5186f444bfcdd3744554-image-left-xs.jpg";